/* eslint-disable */

import { Loader } from 'google-maps';
import { style } from './mapStyle';
import { Popup } from './popup';
import { windowWidth } from './utils';

type Marker = {
  id: string;
  name: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  country: string;
  type: Type;
  url: string;
  phone: string;
  email: string;
  zip: string;
  lat: string;
  lng: string;
  distance: string;
};

enum Type {
  EVENT_STYLIST = 'Event Stylist',
  STOCKIST = 'Stockist',
}

const storeFinder = {
  map: null as any,
  loader: new Loader('AIzaSyC3Pep87jmCbuirH_G2_Ftd0f5A08cUYpw', {
    libraries: ['places', 'geometry'],
  }),
  markers: (window as any).markerJSON as Marker[],
  filterdMarkers: [] as Marker[],
  storeList: document.getElementById('storeList') as HTMLElement | undefined,
  resultWrap: document.getElementById('resultWrap') as HTMLElement | undefined,
  resultBtn: document.getElementById('resultTrigger') as
    | HTMLElement
    | undefined,
  typeBtns: document.querySelectorAll('.jsType') as NodeListOf<HTMLElement>,
  selectedTypes: [] as Type[],
  bounds: {} as google.maps.LatLngBounds,
  search: document.getElementById('searchStoreInput') as
    | HTMLInputElement
    | undefined,
  section: document.getElementById('jsSection') as HTMLElement | undefined,
  newSearch: document.getElementById('jsNewSearch') as HTMLElement | undefined,
  messageElement: document.getElementById('messageElement') as
    | HTMLElement
    | undefined,
  autocomplete: undefined as google.maps.places.Autocomplete | undefined,
  lat: 0,
  lng: 0,
  pins: [] as google.maps.Marker[],
  typeFilterOpen: document.getElementById('typeFilterOpen') as
    | HTMLElement
    | undefined,
  typeFilter: document.getElementById('typeFilter') as HTMLElement | undefined,
  markerCount: document.getElementById('markerCount') as
    | HTMLElement
    | undefined,
  resetMarkers: document.getElementById('markerReset') as
    | HTMLElement
    | undefined,
  defaultZoomLevel: 10,
  errorMessage: document.getElementById('errorMessage') as
    | HTMLElement
    | undefined,
  totalResultsElement: document.getElementById('totalResults') as
    | HTMLElement
    | undefined,
  toggleList: document.getElementById('jsToggleList') as
    | HTMLElement
    | undefined,
  toggleMap: document.getElementById('jsToggleMap') as HTMLElement | undefined,
  mapWrap: document.getElementById('jsMapWrap') as HTMLElement | undefined,
  stockistAds: document.getElementById('jsStockistWrap') as
    | HTMLElement
    | undefined,
  storeFinder: document.getElementById('jsStoreFinder') as HTMLElement | undefined,

  init() {
    this.loadMap();
    this.setMarkers();
    this.setTriger();
    this.filterTypes();
    this.zoomToPin();
    this.toggleFilter();
    this.setResetMarkers();
    this.setupNearbyStoresButton();
    this.goBackSearch();

    if (windowWidth < 1200) {
      this.togglers();
      const filterpopup = new Popup('#stfPopup', '#typeFilterOpen', '.jsClose');
      filterpopup.init();
    }
  },

  togglers() {
    this.toggleList?.addEventListener('click', () => {
      this.toggleList?.classList.add('activeClass');
      this.toggleMap?.classList.remove('activeClass');
      this.storeList?.parentElement?.classList.add('activeClass');
      this.mapWrap?.classList.remove('activeClass');
    });

    this.toggleMap?.addEventListener('click', () => {
      this.toggleList?.classList.remove('activeClass');
      this.toggleMap?.classList.add('activeClass');
      this.storeList?.parentElement?.classList.remove('activeClass');
      this.mapWrap?.classList.add('activeClass');
    });
  },

  setCounter() {
    const countMessage = this.filterdMarkers.length
      ? `See ${this.filterdMarkers.length} Locations`
      : 'Select Option';

    if (this.markerCount) {
      this.markerCount.innerText = countMessage;
    }

    // Update the total results element
    if (this.totalResultsElement) {
      this.totalResultsElement.innerText = `${this.filterdMarkers.length} Result(s) Found`;
    }
  },

  setupNearbyStoresButton() {
    const findNearbyStoresBtn = document.getElementById('findNearbyStores');
    findNearbyStoresBtn?.addEventListener('click', () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.handleGeoSuccess.bind(this),
          this.handleGeoError,
        );

      } else {
        alert('Geolocation is not supported by this browser.');
      }
    });
  },

  goBackSearch() {
    this.newSearch?.addEventListener('click', () => {
      this.resultWrap?.classList.remove('activeClass');
      this.stockistAds?.classList.remove('activeClass');
      if (this.search) {
        this.search.value = '';
      }
      this.moveSectionDown(); 
      this.hideErrorMessage();
    });

    
   
    
  },

  handleGeoSuccess(position) {
    this.lat = position.coords.latitude;
    this.lng = position.coords.longitude;

    console.log(`User's location: lat: ${this.lat}, lng: ${this.lng}`);

    this.map.setCenter({ lat: this.lat, lng: this.lng });
    this.map.setZoom(this.defaultZoomLevel);

    this.filterMarkers();
    this.setMarkers();
    this.addPins();
    this.setCount();

    const findNearbyStoresBtn = document.getElementById('findNearbyStores');
    if (findNearbyStoresBtn) {

      if (this.filterdMarkers.length === 0) {


        findNearbyStoresBtn.classList.add('activeClass');
        findNearbyStoresBtn.innerHTML = `
      <svg>
				<use xlink:href="#icon-location"></use>
			</svg>
        No Stores Found Nearby
        `;  
       
        findNearbyStoresBtn.addEventListener('click', () => {
          if(scrollY < 330) {
            this.smoothScrollBy('jsStoreFinder', 600);
          }
        })

      } else {
        findNearbyStoresBtn.classList.remove('activeClass');
        findNearbyStoresBtn.innerHTML = `
      <svg>
				<use xlink:href="#icon-location"></use>
			</svg>
        Find Stores Near Me
        `;

        this.moveSectionUp();
   
        setTimeout(() => {
          this.resultWrap?.classList.add('activeClass');
          this.stockistAds?.classList.add('activeClass');
          window.scrollTo(0,0);
        }, 500);

   
      }
    }

    this.adjustMapBounds();
  },

  handleGeoError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        alert('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        alert('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        alert('An unknown error occurred.');
        break;
    }
  },

  setResetMarkers() {
    this.resetMarkers?.addEventListener('click', () => {
      this.typeBtns.forEach((item) => item.classList.remove('activeClass'));
      this.lat = 0;
      this.lng = 0;
      this.selectedTypes = [];
      if (this.search) {
        this.search.value = '';
      }
      this.filterdMarkers = [];
      this.setMarkers();
      this.addPins();
      this.setCount();
      this.hideErrorMessage();
    });
  },

  setCount() {
    if (this.markerCount) {
      this.markerCount.innerText = this.filterdMarkers.length
        ? `See ${this.filterdMarkers.length} Locations`
        : 'Select Option';
    }
  },

  toggleFilter() {
    this.typeFilterOpen?.addEventListener('click', () => {
      this.typeFilterOpen?.classList.toggle('activeClass');
      this.typeFilter?.classList.toggle('activeClass');
    });
  },

  zoomToPin() {
    this.storeList?.addEventListener('click', (e) => {
      const el = e.target as HTMLElement;
      if (el.classList.contains('jsMarkerLink')) {
        const lat = el.dataset.lat as string;
        const lng = el.dataset.lng as string;
        this.resultWrap?.classList.add('activeClass');
        this.resultBtn?.classList.add('activeClass');
        this.map.panTo({ lat: +lat, lng: +lng });
        this.map.setZoom(15);
        // this.resultWrap?.scrollIntoView({ behavior: "smooth" });
      }
    });
  },

  getAtuoComResult() {
    const place = this.autocomplete?.getPlace();
    if (!place?.geometry) {
      window.alert("Autocomplete's returned place contains no geometry");
      return;
    }
    this.lat = place.geometry.location.lat();
    this.lng = place.geometry.location.lng();

    this.map.setCenter({ lat: this.lat, lng: this.lng });
    this.map.setZoom(0);

    this.filterMarkers();
    this.setMarkers();
    this.addPins();
    this.setCount();

    if (this.filterdMarkers.length === 0) {
      this.showErrorMessage();
    } else {
      this.hideErrorMessage();
      this.moveSectionUp();
      setTimeout(() => {
        window.scrollTo(0,0);
        this.resultWrap?.classList.add('activeClass');
        this.stockistAds?.classList.add('activeClass');
      }, 500);
    }

   


  },

  showErrorMessage() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';
    }
  },

  hideErrorMessage() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  },

  filterTypes() {
    this.typeBtns.forEach((item) => {
      item.addEventListener('click', () => {
        const type = item.dataset.type as Type;
        if (this.selectedTypes.includes(type)) {
          this.selectedTypes = this.selectedTypes.filter(
            (item) => item !== type,
          );
          item.classList.remove('activeClass');
        } else {
          this.selectedTypes.push(type);
          item.classList.add('activeClass');
        }
        this.setAll();
      });
    });
  },

  setAll() {
    this.filterMarkers();
    this.setMarkers();
    this.addPins();
    this.setCount();
    this.adjustMapBounds();
  },

  filterMarkers() {
    let markers = [...this.markers];
    if (this.lat && this.lng) {
      markers = markers
        .map((item) => {
          return { ...item, distance: this.calcDistance(item) };
        })
        .filter((item) => +item.distance < 20)
        .sort((a, b) => +a.distance - +b.distance);
    }
    if (this.selectedTypes.length) {
      markers = markers.filter((item) =>
        this.selectedTypes.includes(item.type),
      );
    }
    this.filterdMarkers = markers;

    this.setCounter();
  },

  createInfo(marker: Marker) {
    return `<h5 class="store-finder__info-title">${marker.name}</h5>
            <p class="store-finder__info-text">${
              marker.street1 ? marker.street1 + ',' : ''
            } 
            ${marker.street2 ? marker.street2 + ',' : ''} 
            ${marker.city}, ${marker.state}, ${marker.country}, ${
              marker.zip
            }</p>`;
  },

  addPins() {
    this.deletePins();
    this.filterdMarkers.forEach((item) => {
      const position = { lat: +item.lat, lng: +item.lng };
      const pin = new google.maps.Marker({
        position,
        map: this.map,
      });
      this.bounds.extend(position);
      const infowindow = new google.maps.InfoWindow({
        content: this.createInfo(item),
      });
      pin.addListener('click', () => {
        infowindow.open(this.map, pin);
      });
      this.pins.push(pin);
    });

    this.adjustMapBounds();
  },

  adjustMapBounds() {
    this.bounds = new google.maps.LatLngBounds();
    this.filterdMarkers.forEach((item) => {
      const position = { lat: +item.lat, lng: +item.lng };
      this.bounds.extend(position);
    });
    if (this.filterdMarkers.length) {
      this.map.fitBounds(this.bounds);
      const currentZoom = this.map.getZoom();
      this.map.setZoom(Math.max(currentZoom, 10));
    }
  },

  setMapOnAll(map: google.maps.Map | null) {
    this.pins.forEach((item) => item.setMap(map));
  },

  hidePins(): void {
    this.setMapOnAll(null);
  },

  showPins(): void {
    this.setMapOnAll(this.map);
  },

  deletePins(): void {
    this.bounds = new google.maps.LatLngBounds();
    this.hidePins();
    this.pins = [];
  },

  calcDistance(store: Marker) {
    const center = new google.maps.LatLng(this.lat, this.lng);
    const marker = new google.maps.LatLng(+store.lat, +store.lng);
    const dist = (
      google.maps.geometry.spherical.computeDistanceBetween(center, marker) /
      1000
    ).toFixed(2);

    return dist;
  },

  setTriger() {
    this.resultBtn?.addEventListener('click', () => {
      this.resultWrap?.classList.toggle('activeClass');
      this.resultBtn?.classList.toggle('activeClass');
    });
  },

  setMarkers() {
    if (this.storeList) {
      this.storeList.innerHTML = this.filterdMarkers
        .map((item, index) => this.createHtml(item, index + 1))
        .join('');
    }
  },

  createHtml(marker: Marker, index: number) {
    return `<li class="store-finder__item" data-type="${marker.type}">
                <div class="store-finder__item-title-wrap">
                    <h3 class="store-finder__item-title jsMarkerLink" data-lat="${
                      marker.lat
                    }" data-lng="${marker.lng}">

                    <div class="store-finder__counter-wrap">
                    <div class="store-finder__count">
                    ${index} 
                    </div>
                    <svg>
                        <use xlink:href="#icon-marker"></use>
                    </svg> 
                    </div>
                     ${marker.name}
                    </h3>
                    <p class="store-finder__item-subtext mobile-hide">
                    ( 
                    ${marker.distance ? marker.distance + 'km' : ''}
                    from your location
                    )
                    </p>
                </div>
                <div class="store-finder__item-links">
                    <p class="store-finder__item-link-wrap">
  
                    <span class="store-finder__item-link">
                      ${marker.street1 ? marker.street1 + ',' : ''}
                      ${marker.street2 ? marker.street2 + ',' : ''} 
                      ${marker.city}, ${marker.state}, ${marker.country}, ${
                        marker.zip
                      }
                    </span>
                    </p>
                    <a href="tel:${
                      marker.phone
                    }" class="store-finder__item-link-wrap">
                    <svg>
                        <use xlink:href="#icon-phone"></use>
                    </svg>
                    <span class="store-finder__item-link">${marker.phone}</span>
                    </a>
                </div>
  
                    <p class="store-finder__item-subtext desktop-hide">
                    ( 
                    ${marker.distance ? marker.distance + 'km' : ''}
                    from your location
                    )
                    </p>
  
            </li>`;
  },

  async loadMap() {
    const mapDiv = document.getElementById('map');
    if (mapDiv) {
      const google = await this.loader.load();

      this.map = new google.maps.Map(mapDiv, {
        zoom: 0,
        center: { lat: -34.9285, lng: 138.6007 },
        styles: style,
        // disableDefaultUI: true,
        // gestureHandling: "cooperative",
      } as google.maps.MapOptions);

      if (this.search) {
        this.autocomplete = new google.maps.places.Autocomplete(this.search, {
          fields: ['address_components', 'geometry', 'icon', 'adr_address'],
          componentRestrictions: { country: ['NZ', 'AU'] },
        });
        this.autocomplete.addListener('place_changed', () => {
          this.getAtuoComResult();
          this.setAll();
        });

        this.search.addEventListener('click', () => {
          if(scrollY < 330) {
            this.smoothScrollBy('jsStoreFinder', 600);
          }

      });

      }
    }
  },

  moveSectionUp() {
    if (this.section) {
      this.section.classList.add('activeClass');
    }
  },


  smoothScrollBy(elementId, duration) {
    const targetElement = document.getElementById(elementId);
    if (!targetElement) return; 

    const startPosition = window.scrollY; 
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY; 
    const distance = targetPosition - startPosition; 
    const startTime = performance.now(); 

   
    function animateScroll(currentTime) {
        const elapsed = currentTime - startTime; 
        const progress = Math.min(elapsed / duration, 1); 

   
        const ease = progress < 0.5
            ? 4 * progress * progress * progress
            : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1;

   
        const scrollAmount = distance * ease;

        
        window.scrollTo(0, startPosition + scrollAmount);

        if (progress < 1) {
            requestAnimationFrame(animateScroll); 
        }
    }

    requestAnimationFrame(animateScroll); 
  },


  moveSectionDown() {
    if (this.section) {
      this.section.classList.remove('activeClass');
    }
  },


};

export default storeFinder;
